var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemperature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 125 100",
    style: {
      enableBackground: "new 0 0 125 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#000000;}\r\n\t.st1{fill:#EE7203;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.6,63.2c-0.7,0-1.3,0.7-1.3,1.3v20.7H29.1V58.5c0-0.7-0.7-1.3-1.3-1.3c-0.7,0-1.3,0.7-1.3,1.3v28.1 c0,0.7,0.7,1.3,1.3,1.3h72c0.7,0,1.3-0.7,1.3-1.3V64.5C100.9,63.6,100.2,63.2,99.6,63.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.5,33.9c0.7,0,1.3-0.7,1.3-1.3V15H98v20.7c0,0.7,0.7,1.3,1.3,1.3c0.7,0,1.3-0.7,1.3-1.3V13.4 c0-0.7-0.7-1.3-1.3-1.3h-72c-0.7,0-1.3,0.7-1.3,1.3v19C26.2,33.3,26.9,33.9,27.5,33.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M108.9,56.2L94.2,41.3c-0.2-0.2-0.7-0.4-1.1-0.4s-0.7,0.2-1.1,0.7L71.7,69.8l-16.3-43 c-0.2-0.4-0.7-0.9-1.1-0.9s-1.1,0.2-1.3,0.7L38.5,55.8l-9.6-14.3c-0.2-0.4-0.7-0.7-1.1-0.7c-0.4,0-0.9,0.2-1.1,0.7L15.7,57.8 c-0.4,0.7-0.2,1.6,0.4,2c0.7,0.4,1.6,0.2,2-0.4L28,44.9l9.8,14.5c0.2,0.4,0.7,0.7,1.1,0.7c0.4,0,0.9-0.2,1.1-0.7L54.3,31l16.1,42.4 c0.2,0.4,0.7,0.9,1.1,0.9h0.2c0.4,0,0.9-0.2,1.1-0.7l21-29.2l13.6,13.8c0.4,0.4,1.3,0.4,2,0C109.6,57.6,109.6,56.7,108.9,56.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperature);
export default __webpack_public_path__ + "static/media/temperature.fdeaa6a1150afea26a492f08fc5390e9.svg";
export { ForwardRef as ReactComponent };